module.exports = __webpack_public_path__ + "static/lean-ef372682a097fd7e2dfdf0938f9621ca.png";